import {
  API_TEAM_BY_ID,
  API_TEAM_CREATE,
  API_TEAM_DELETE,
  API_TEAM_LIST,
  API_TEAM_STATS,
  API_TEAM_UPDATE,
  API_TEAM_USER_TEAMS,
} from 'config'
import Api from 'services/api'

export interface Team {
  id: number
  name: string
  memberIds: number[]
  visible: boolean
  createdAt: string
  updatedAt: string
  createdBy: number
  updatedBy: number
}

export interface CreateTeamData {
  name: string
  memberIds: number[]
  visible?: boolean
}

export interface UpdateTeamData {
  name: string
  memberIds: number[]
  visible?: boolean
}

export const getTeams = (includeInvisible: boolean = false): Promise<Team[]> => {
  return Api.get(API_TEAM_LIST, { includeInvisible })
}

export const getTeamById = (id: number): Promise<Team> => {
  return Api.get(API_TEAM_BY_ID, {}, { id })
}

export const createTeam = (data: CreateTeamData): Promise<Team> => {
  return Api.post(API_TEAM_CREATE, data)
}

export const updateTeam = (id: number, data: UpdateTeamData): Promise<Team> => {
  return Api.put(API_TEAM_UPDATE, data, { id })
}

export const deleteTeam = (id: number): Promise<void> => {
  return Api.delete(API_TEAM_DELETE, {}, { id })
}

export const getTeamStats = (): Promise<any> => {
  return Api.get(API_TEAM_STATS)
}

export const getUserTeams = (userId: number): Promise<Team[]> => {
  return Api.get(API_TEAM_USER_TEAMS, {}, { userId })
}
